module.exports = __webpack_public_path__ + "static/img/BuildSetting.37c263fd.png";